
export default "/assets/inbox-mini.6bd91f54.svg"